module.exports = __webpack_public_path__ + "img/icon_map_3_on_101.0139e330.png";